import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Brands.css";

const ClientsSection = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiBrands", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setBrands(response.data.data);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  }, []);

  const settings = {
            slidesToShow: 8,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,  
            arrows: false,
            dots: false,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            }, {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3
                }
            }]
  };

  return (
    <section className="clients">
      <div className="container mx-auto px-4">
      <div className="row b-member-info">
          <div className="col-xs-12 col-sm-4">
          <div className="b-mod-heading">
            <p className="first-heading font-secondary member-prof">Brands We Are</p>
            <h4 className="heading-line line-right customColor customPseudoElBg member-name" >
            <strong>Empowering</strong>
            </h4>
		  </div>
          </div>
          <div className="col-xs-12 col-sm-8">
           <div className="b-member-caption">
                <h6 className="contact-info-title customPseudoElBg font-secondary">PROUDLY EMPOWERING SUCCESSFUL BRANDS</h6>
                <p>Helping Startups, SMBs & Large Enterprise brands globally!</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid mx-auto mt-8">
        {brands.length > 0 ? (
          <Slider {...settings}>
            {brands.map((brand, index) => (
              <div className="slide1" key={index}>
                <img
                  src={`https://www.isolsgroup.com/new/uploaded-images/client/${brand.client_image}`}
                  alt={brand.client_name || "Brand logo"}
                  className="w-full object-contain brand-logo"
                  loading="lazy"
                />
              </div>
            ))}
          </Slider>
        ) : (
          <p className="text-center mt-4">No brands available.</p>
        )}
      </div>
    </section>
  );
};

export default ClientsSection;
